/**
 * Browser download helpers for ESX files.
 *
 * The backend returns the encrypted .ESX as base64 (the `/esx/.../json`
 * endpoint). These helpers turn that into a real browser download without
 * needing a server-side file URL.
 */

/** Decode a base64 string into a Blob. */
export function base64ToBlob(b64: string, mime = 'application/octet-stream'): Blob {
  const binary = atob(b64);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return new Blob([bytes], { type: mime });
}

/**
 * Trigger a browser download of a base64-encoded ESX file.
 *
 * Creates an object URL for the decoded bytes, clicks a transient anchor, and
 * revokes the URL so it doesn't leak.
 */
export function triggerEsxDownload(filename: string, esxB64: string): void {
  const blob = base64ToBlob(esxB64);
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
